import { AppInjector } from 'app/classes/app-injector/app-injector';
import { HTTP } from '@ionic-native/http/ngx';

let http: HTTP;

export const fetchUrl = <T>(url: string, parameters = { }, headers = { }): Promise<T> => {
  http = http || AppInjector.prepare().get(HTTP);

  return http.get(encodeURI(url), parameters, headers).then(({ data }) => JSON.parse(data));
};